/* 广告组件 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';

class AdComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.any,
        componentOptions: PropTypes.object,
    };

    render() {
        const { content, componentOptions } = this.props;
        const dataKey = componentOptions.dataKey || 'allData';
        const ad = window[dataKey][content];

        // dataKey是数据来源，默认是allData
        // content是从allData里查已格式化的数据用的
        console.log('AdComponent', content, ad);

        return <Ad styleName={styles.ad} content={ad} />;
    }
}

export default errorBoundary(AdComponent);
